<template>
	<div class="Kontakt">
		<div class="container">
			<h1>{{ $t('navigationKontakt.title') }}</h1>
			<div class="row align-items-center h-50">
				<div class="py-5 col-9">
					<div>
						<div class="Kontaktdaten mb-4">
							<div class="mb-1">Alexander Bankovski</div>
							<div>Theodor Heuss Straße 37</div>
							<div class="mb-5">95213 Münchberg</div>
							<div>
								E-Mail: <a href="mailto: info@sos-p.com">info@sos-p.com</a>
							</div>
							<div>Tel: <a href="tel: 09251 8998639">09251 8998639</a></div>
						</div>
						<div v-if="consentAllowed || googleMapsIsAllowed">
							<div v-if="matchScreenSize">
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2662.454100110216!2d11.524421115131522!3d48.140050058968555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479e761fd687e1f9%3A0x328090e16a5860e3!2sLandsberger%20Str.%20155%2C%2080687%20M%C3%BCnchen!5e0!3m2!1sde!2sde!4v1600027962916!5m2!1sde!2sde"
									width="500"
									height="450"
									frameborder="0"
									style="border: 0"
									allowfullscreen=""
									aria-hidden="false"
									tabindex="0"
								></iframe>
								<div
									v-if="!consentAllowed"
									v-on:click="onDisallowApp()"
									class="Kontakt__OptOutRequest"
								>
									{{ $t('navigationKontakt.revokeMapsPermissionButtton') }}
								</div>
							</div>
							<div v-else>
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2662.454100110216!2d11.524421115131522!3d48.140050058968555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479e761fd687e1f9%3A0x328090e16a5860e3!2sLandsberger%20Str.%20155%2C%2080687%20M%C3%BCnchen!5e0!3m2!1sde!2sde!4v1600027962916!5m2!1sde!2sde"
									width="310"
									height="480"
									frameborder="0"
									style="border: 0"
									allowfullscreen=""
									aria-hidden="false"
									tabindex="0"
								></iframe>
								<div
									v-if="!consentAllowed"
									v-on:click="onDisallowApp()"
									class="Kontakt__OptOutRequest"
								>
									{{ $t('navigationKontakt.revokeMapsPermissionButtton') }}
								</div>
							</div>
						</div>
						<div v-else>
							<google-apps-overlay
								:description="$t('navigationKontakt.blockerTextMaps')"
								type="maps"
								@onAllowApp="onAllowApp"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import GoogleAppsOverlay from '@/components/GoogleAppsOverlay'

export default {
	name: 'Kontakt',
	components: {
		GoogleAppsOverlay
	},

	data() {
		return {
			consentAccepted: false
		}
	},
	computed: {
		matchScreenSize() {
			return window.screen.availWidth >= 568
		},
		consentAllowed() {
			return this.$store.getters.cookieIsSet
		},
		googleMapsIsAllowed() {
			return this.$store.getters.googleMapsIsAllowed
		}
	},
	methods: {
		onAllowApp() {
			this.$store.commit('onAllowGoogleMaps')
		},
		onDisallowApp() {
			this.$store.commit('onDisallowGoogleMaps')
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_kontakt.json'),
			en: require('@/i18n/en/eng_kontakt.json')
		}
	}
}
</script>

<style scoped lang="stylus">
.OptOutButton {
	float: right;
	border: rgba(255,255,255,0.6) 1px solid;
	padding: 10px;
	text-transform: uppercase;
	transition: transform .2s;
	cursor: pointer;
}

.Kontakt__OptOutRequest {
	margin-top: 10px;
	font-size: 10px;
	cursor: pointer;
}
a {
	color: red;
}
</style>
